import { FormLabel, Box, Typography, RadioGroup, FormControlLabel, Radio, FormControl, FormHelperText, Select, InputAdornment, TextField, makeStyles } from "@material-ui/core";
import { useObserver, FieldType, IModel, EditableInput } from "@shoothill/core";
import FormSectionViewModelBase from "Globals/ViewModels/FormSections/FormSectionViewModelBase";
import styled from "styled-components";
import { IViewModel, ViewModelBase } from "@shoothill/core/dist/ViewModels";
import React, { useEffect } from "react";
import { theme } from "Globals/Styles/AppTheme";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ParsableDate } from "@material-ui/pickers/constants/prop-types";
import DateFnsUtils from "@date-io/date-fns";
import { useMediaQuery } from "@shoothill/core";

interface IProps<T extends IModel<T>> {
    viewModel: IViewModel<T> & ViewModelBase<T>;
    fieldName: keyof FieldType<T>;
    value: ParsableDate;
    onChange: (val: MaterialUiPickersDate) => void;
    label?: string;
    placeholder?: string;
    minDate?: Date | null;
    maxDate?: Date | null;
    disabled?: boolean;
    disablePast?: boolean;
    error?: string;
    resetCallback?: any;
}

const useStyles = makeStyles((theme) => ({
    wrapper: {
        "& .MuiFormControl-root": {
            "@media(max-width: 767px)": {
                width: "100% !important",
            },
        },
    },
    datePicker: {
        "& .MuiFormLabel-root": {
            "@media(max-width: 767px)": {
                fontSize: "16px !important",
                whiteSpace: "normal",
                position: "relative",
                marginBottom: "-10px",
            },
        },
    },
}));

export function CustomDatePicker<T extends IModel<T>>(props: IProps<T>) {
    const classes = useStyles();

    return useObserver(() => (
        <Box className={classes.wrapper}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                {
                    <KeyboardDatePicker
                        className={classes.datePicker}
                        style={props.viewModel.getError(props.fieldName) !== "" ? { borderBottom: "2px solid red" } : {}}
                        value={props.value}
                        id={`${props.fieldName}-picker-dialog`}
                        label={<span style={props.viewModel.getError(props.fieldName) !== "" ? { color: theme.palette.error.main } : {}}>{props.label}</span>}
                        format="dd/MM/yyyy"
                        onChange={(date: MaterialUiPickersDate) => {
                            props.onChange(date);
                        }}
                        disablePast={props.disablePast}
                        minDate={props.minDate}
                        maxDate={props.maxDate}
                        placeholder={props.placeholder}
                        disabled={props.disabled}
                        onYearChange={() => props.resetCallback()}
                        onMonthChange={() => props.resetCallback()}
                        onOpen={() => props.resetCallback()}
                    />
                }
            </MuiPickersUtilsProvider>
            {props.error != "" ? (
                <>
                    <p style={{ color: theme.palette.error.main, position: "absolute", fontSize: "14px" }}>{props.error}</p>
                </>
            ) : (
                <>
                    {props.viewModel.getError(props.fieldName) !== "" && (
                        <p style={{ color: theme.palette.error.main, position: "absolute", fontSize: "14px" }}>{props.viewModel.getError(props.fieldName)}</p>
                    )}
                </>
            )}
        </Box>
    ));
}
